import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import {
  MessageService,
  MessageOnOnline,
  MessageOnOffline,
  MessageSettingsReady,
  MessageSelectedVoiceTypeOnChange,
  MessageFreeVoicesReady,
  MessagePremVoicesReady,
  MessageIsDyslexicChanged,
  MessagePlusVoicesReady,
  MessageIsCCChanged,
  MessageVoiceOnChange,
  MessageIsAutoScrollChanged,
  MessageIsTextSpacingChanged,
  MessageSpeedOnChange,
  MessageSelectVoiceOfLang,
  MessageSleepTimer,
  // MessageCordovaAndroidStore
  MessageBeHighlightedChanged,
  MessageClonedVoicesReady,
  MessageUserUpdated,
  MessageStopReader,
  MessageBeforeUnload,
  MessageThemeChange,
  // TODO MessageCordovaStop,
  // TODO MessageCordovaOfflineMode
} from './message.service';
import { PremVoicesService, PremVoice } from './voices-prem.service';
import { FreeVoicesService, FreeVoice, VoiceType } from './voices-free.service';
import { AppService } from './app.service';
import { OnlineOfflineService } from './online-offline.service';
import { UtilService } from './util.service';
import { PlusVoice, SimplePlusVoicesService } from './voices-plus-simple.service';
import { AmplifyControllerService } from './amplify-controller.service';
import { environment } from 'src/environments/environment';
declare const $: any;

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  public settingsReady: boolean = false;
  private selectedVoiceType: string;
  private selectedFreeVoice: string = '';
  private selectedPremVoice: string = '';
  public selectedPlusVoice: string = '';
  private selectedVoiceLanguage: string = '';
  public pinnedVoices: Array<string> = [];
  public pinnedCommunityVoices: Array<string> = [];
  private lastSelectedNonGooglePremVoice: string = '';
  private lastSelectedPlusVoice: string = '';
  private lastSelectedNonClonedPlusVoice: string = '';
  private speed: number = 180;
  public volume: number = 0.75;
  public displayVolume: string = (this.volume * 100).toFixed(0);

  private isDyslexic: boolean = false;
  private isTextSpacing: boolean = false;
  public beHighlighted = ['sentence', 'word'];
  private hasHighlight: boolean = true;
  public highlightColour: string = 'blue';
  public fontSize: number = 18;
  public isAutoScroll: boolean = true;

  private defaultFreeVoice: string = '';
  private defaultPremVoice: string = '';
  private defaultPlusVoice: string = 'Adam en-US plus ms 235';

  public isCC: boolean = true;

  public skipRoundBrackets: boolean = true;
  public skipSquareBrackets: boolean = true;
  public skipCurlyBrackets: boolean = true;

  public skipUrls: boolean = true;
  public skipTable: boolean = true;
  public skipFigure: boolean = true;
  public skipHeaderFooter: boolean = true;
  public skipScripts: boolean = true;
  public skipVertical: boolean = true;
  public pdfSkippables: Set<string> = new Set(['header-footer-footnote', 'figure', 'figure-caption', 'table', 'table-caption', 'formula']);

  public sleepIsStart: boolean = false;
  public sleepIsPause: boolean = false;
  public sleepTotalTimerGap: number = 30 * 60;
  public sleepCurrentTimerGap: number = 0;
  public alarmTimeStamp: number = 0;
  public static MAX_TOTAL_TIMER: number = 45 * 60;
  public static MIN_TOTAL_TIMER: number = 1 * 60;
  public static SLEEP_TIMER_ONE_GAP: number = 1 * 60;

  public annotationDefualtColor: string = 'yellow';

  onloaded: Promise<void>;
  resolveOnLoaded: () => void;
  waitForCloned: Promise<void>;
  resolveWaitForCloned: () => void;

  // //Android in-app purchase plugin v13:
  // private transactionPurchaseTime: number = 0;
  // public transactionPurchaseToken = null;
  // public transactionPurchaseId = null;

  constructor(
    private storageService: StorageService,
    private messageService: MessageService,
    private premVoicesService: PremVoicesService,
    private simplePlusVoicesService: SimplePlusVoicesService,
    private freeVoicesService: FreeVoicesService,
    // private userActionsTrackingService: UserActionsTrackingService,
    private onlineOfflineService: OnlineOfflineService,
    private utilService: UtilService,
    private amplifyControllerService: AmplifyControllerService
  ) {
    // window.addEventListener('beforeunload', () => {
    //   this.updateSyncSettingsWithFetch();
    //   this.messageService.sendMessage({ name: MessageStopReader });
    //   this.messageService.sendMessage({ name: MessageBeforeUnload });
    // });
    this.onloaded = new Promise((resolve) => {
      this.resolveOnLoaded = resolve;
    });
    this.waitForCloned = new Promise((resolve) => {
      this.resolveWaitForCloned = resolve;
    });
    console.log("settings service")
    if (AppService.isPW() || AppService.isAndroid() || AppService.isIOS()) {
      this.selectedVoiceType = 'prem';
    } else {
      this.selectedVoiceType = 'free';
    }

    this.messageService.getMessage().subscribe(message => {
      if (message.name === MessageOnOnline) {
        this.onOnline();
      } else if (message.name === MessageOnOffline) {
        this.onOffline();
      } else if (message.name === MessageFreeVoicesReady) {
        let freeVoices = this.freeVoicesService.getVoices();
        if (freeVoices.size > 0) {
          if (AppService.isPW() || AppService.isAndroid()) {
            this.defaultFreeVoice = this.freeVoicesService.getVoices().entries().next().value[0];
          } else if (AppService.isIOS()) {
            this.defaultFreeVoice = 'Samantha en-US free'; //Daniel en-GB  Samantha en-US
            let isFound = false;
            for (let voice of Array.from(this.freeVoicesService.getVoices().values())) {
              if (voice.name == this.defaultFreeVoice) {
                isFound = true;
                break;
              }
            }
            if (!isFound) {
              this.defaultFreeVoice = this.freeVoicesService.getVoices().entries().next().value[0];
            }
            //if (this.get)
          } else {
            for (const [key, voice] of this.freeVoicesService.getVoices()) {
              if (voice.source === 'local aca' || voice.source === 'local att' || voice.source === VoiceType.iosAca) {
                this.defaultFreeVoice = key;
                break;
              }
            }
            if (this.defaultFreeVoice == "") {
              this.defaultFreeVoice = this.freeVoicesService.getVoices().entries().next().value[0];
            }
          }
        }
        if (AppService.isSoftware()) {
          this.onload();
        }
      } else if (message.name === MessageSelectVoiceOfLang) {
        if (message.data && message.data.lang) {
          this.selectVoiceOfLang(message.data.lang);
        }
      } else if (message.name === MessageSleepTimer) {
        if (message.data && message.data.event) {
          if (message.data.event === 'start') {
            this.sleepIsStart = true;
          } else if (message.data.event === 'pause') {
            this.sleepIsPause = true;
          } else if (message.data.event === 'resume' && message.data.value && message.data.total) {
            this.sleepIsPause = false;
            this.alarmTimeStamp = Date.now() + (this.sleepTotalTimerGap - this.sleepCurrentTimerGap) * 1000;
          } else if (message.data.event === 'progress' && message.data.value && message.data.total) {
            this.sleepCurrentTimerGap = message.data.value;
          } else if (message.data.event === 'end' || message.data.event === 'terminate') {
            this.sleepIsStart = false;
            this.sleepIsPause = false;
            this.sleepCurrentTimerGap = 0;
          }
        }
      } else if (message.name === MessageClonedVoicesReady) {
        this.resolveWaitForCloned();
      } else if (message.name === MessageUserUpdated) {
        // only update sync settings on user updated after the initial onload to avoid duplicate calls
        if (this.settingsReady) {
          this.initSettings();
        }
      } else if (message.name === MessageThemeChange) {
        this.updateSyncSettings();
      }
      // else if (message.name === MessageWindowOnFocus) {
      //   // update sync settings when window is focused
      //   this.debouncedUpdateSyncSettings();
      // }
      // TODO
      // else if (message.name == MessageCordovaOfflineMode) {
      //   this.onOffline();
      // }

      if (AppService.isPW() || AppService.isAndroid() || AppService.isIOS()) {
        if (message.name === MessagePremVoicesReady) {
          console.log("prem voices ready");
          this.defaultPremVoice = this.premVoicesService.getVoices().entries().next().value[0];
          this.onload();
        } else if (message.name === MessagePlusVoicesReady) {
          // this.defaultPlusVoice = this.simplePlusVoicesService.getVoices().entries().next().value[0];
          this.defaultPlusVoice = 'Adam en-US plus ms 235';
        }
      }
      // if (AppService.isAndroid()) {
      //   if (message.name === MessageCordovaAndroidStore) {
      //     if (message.data != null) {
      //       if (message.data.rst == 'finish') {
      //           let transaction = message.data.transaction;
      //           if (transaction && transaction.nativePurchase.purchaseTime > this.transactionPurchaseTime) {
      //             this.transactionPurchaseTime = transaction.nativePurchase.purchaseTime;
      //             this.transactionPurchaseToken = transaction.nativePurchase.purchaseToken;
      //             this.transactionPurchaseId = transaction.nativePurchase.productId;
      //           }
      //         }
      //       }
      //   }
      // }
    });
  }

  public onload(): Promise<any> {
    return new Promise((resolve) => {
      this.initSettings();
      this.resolveOnLoaded();
      console.log("resolve onloaded");
      resolve(null);
    })
      .catch(function (err) {
        console.log('settings onload error', err);
      });
  }

  private async settingsOnReady() {
    try {
      console.log("settingsOnReady");
      await this.checkAccessToSelectedVoices();
      this.removePinnedVoicesNotFound();
      this.settingsReady = true;

      this.messageService.sendMessage({
        name: MessageSettingsReady,
        data: {
          selectedVoiceType: this.selectedVoiceType,
          selectedFreeVoice: this.selectedFreeVoice,
          selectedPremVoice: this.selectedPremVoice,
          selectedPlusVoice: this.selectedPlusVoice,
          isDyslexic: this.isDyslexic,
          isTextSpacing: this.isTextSpacing,
          isAutoScroll: this.isAutoScroll,
          beHighlighted: this.beHighlighted,
          hasHighlight: this.hasHighlight,
          highlightColour: this.highlightColour,
          fontSize: this.fontSize
        }
      });
      console.log("settings ready");
    } catch (err) {
      console.log("settingsOnReady error", err);
    }
  }

  private removePinnedVoicesNotFound() {
    // check if all pinned voices are valid
    let isEdited = false;
    let newPinnedVoices = [];
    this.pinnedVoices.forEach((voiceKey) => {
      try {
        if (voiceKey.includes("plus") && this.getVoiceFromKey(voiceKey).languageName === 'Community') {
          // fabricated community voice
        } else {
          let migratedVoiceKey = this.migrateVoiceKey(voiceKey);
          if (migratedVoiceKey !== voiceKey) {
            isEdited = true;
            voiceKey = migratedVoiceKey;
          }
          let freeExist = this.freeVoicesService.getVoices().get(voiceKey) != null;
          let premExist = this.premVoicesService.getVoices().get(voiceKey) != null;
          let plusExist = this.simplePlusVoicesService.getVoices().get(voiceKey) != null;
          if (!freeExist && !premExist && !plusExist) {
            isEdited = true;
          }
        }
        newPinnedVoices.push(voiceKey);
      } catch (err) {
        isEdited = true;
      }
    });
    this.pinnedVoices = newPinnedVoices;
    if (isEdited) {
      this.setPinnedVoices();
    }
  }

  private initSettings() {
    console.log("initSettings");
    // if offline, init settings from local storage else wait for the last read to init the settings
    this.initSettingsFromLocalStorage();
    if (!this.onlineOfflineService.isOnline) {
      this.settingsOnReady();
    } else {
      this.getSyncSettingsFromAPI()
        .then((settings) => {
          if (settings) {
            this.initSyncSettings(settings);
          } else {
            // if no entry in ddb, sync local settings
            this.updateSyncSettings();
            this.settingsOnReady();
          }
        })
        .catch((err) => {
          console.log("initSettings error", err);
          this.settingsOnReady();
        });
    }
  }

  public async initSyncSettings(settings) {
    try {
      await this.onloaded;
      console.log("initSettings", settings);
      if (!settings) {
        // settings were already initialized from local storage so just need to call settingsOnReady
        return this.settingsOnReady();
      }
      if ('voiceLanguage' in settings) {
        this.setSelectedVoiceLanguage(settings.voiceLanguage);
      }
      if ('voiceType' in settings) {
        this.setSelectedVoiceType(settings.voiceType, false);
      }
      if ('plusVoice' in settings) {
        this.selectedPlusVoice = this.migrateVoiceKey(settings.plusVoice);
        this.storageService.write('pw-plusVoice', this.selectedPlusVoice);
        console.log("set plus voice", this.selectedPlusVoice);
      }
      if ('premVoice' in settings) {
        this.selectedPremVoice = this.migrateVoiceKey(settings.premVoice);
        this.storageService.write('pw-premVoice', this.selectedPremVoice);
      }
      if ('freeVoice' in settings) {
        this.selectedFreeVoice = this.migrateVoiceKey(settings.freeVoice);
        this.storageService.write('pw-freeVoice', this.selectedFreeVoice);
      }
      if ('lastNonGooglePremVoice' in settings) {
        this.lastSelectedNonGooglePremVoice = this.migrateVoiceKey(settings.lastNonGooglePremVoice);
        this.storageService.write('pw-lastNonGooglePremVoice', this.lastSelectedNonGooglePremVoice);
      }
      if ('lastPlusVoice' in settings) {
        this.lastSelectedPlusVoice = this.migrateVoiceKey(settings.lastPlusVoice);
        this.storageService.write('pw-lastPlusVoice', this.lastSelectedPlusVoice);
      }
      if ('lastNonClonedPlusVoice' in settings) {
        this.lastSelectedNonClonedPlusVoice = this.migrateVoiceKey(settings.lastNonClonedPlusVoice);
        this.storageService.write('pw-lastNonClonedPlusVoice', this.lastSelectedNonClonedPlusVoice);
      }
      if ('isAutoScroll' in settings) {
        this.setIsAutoScroll(JSON.parse(settings.isAutoScroll));
      }
      if ('beHighlighted' in settings) {
        this.setBeHighlighted(JSON.parse(settings.beHighlighted));
      }
      if ('highlightColour' in settings) {
        this.setHighlightColour(settings.highlightColour);
      }
      if ('annotationColour' in settings) {
        this.setAnnotationDefaultColor(settings.annotationColour, false);
      }
      if ('volume' in settings) {
        this.setVolume(JSON.parse(settings.volume), false);
      }
      if ('speed' in settings) {
        this.setSpeed(JSON.parse(settings.speed), false);
      }
      if ('fontSize' in settings) {
        this.setFontSize(JSON.parse(settings.fontSize), false);
      }
      if ('isTextSpacing' in settings) {
        this.setIsTextSpacing(JSON.parse(settings.isTextSpacing), false);
      }
      if ('isDyslexic' in settings) {
        this.setIsDyslexic(JSON.parse(settings.isDyslexic), false);
      }
      if ('skipRoundBracket' in settings) {
        this.setSkipRoundBrackets(JSON.parse(settings.skipRoundBracket));
      }
      if ('skipSquareBracket' in settings) {
        this.setSkipSquareBrackets(JSON.parse(settings.skipSquareBracket));
      }
      if ('skipCurlyBracket' in settings) {
        this.setSkipCurlyBrackets(JSON.parse(settings.skipCurlyBracket));
      }
      if ('skipUrl' in settings) {
        this.setSkipUrls(JSON.parse(settings.skipUrl));
      }
      if ('skipScript' in settings) {
        this.setSkipScripts(JSON.parse(settings.skipScript));
      }
      if ('skipVertical' in settings) {
        this.setSkipVertical(JSON.parse(settings.skipVertical));
      }
      if ('pdfSkippables' in settings) {
        let pdfSkippables = new Set(JSON.parse(settings.pdfSkippables)) as Set<string>;
        this.pdfSkippables = pdfSkippables;
        this.storageService.write('pw-pdf-skippables', [...this.pdfSkippables]);
      }
      if ('cc' in settings) {
        this.setIsCC(JSON.parse(settings.cc), false);
      }
      if ('ccMode' in settings) {
        this.storageService.write('pw-cc-mode', settings.ccMode);
      }
      if ('pinnedVoices' in settings) {
        this.pinnedVoices = JSON.parse(settings.pinnedVoices);
        this.setPinnedVoices(false);
      }
      if ('theme' in settings) {
        this.storageService.write('pw-theme', settings.theme);
      }
      console.log("pinnedVoices", this.pinnedVoices);
      return this.settingsOnReady();
    } catch (err) {
      console.log("initSyncSettings error", err);
    }
  }

  private initSettingsFromLocalStorage() {
    return Promise.resolve()
      .then(() => {
        const isCC: boolean = this.storageService.read('pw-cc');
        console.log("isCC", isCC);
        this.isCC = isCC !== null ? isCC : true;

        const skipRoundBrackets: boolean = this.storageService.read('pw-skip-round-bracket');
        this.skipRoundBrackets = skipRoundBrackets !== null ? skipRoundBrackets : true;
        const skipSquareBrackets: boolean = this.storageService.read('pw-skip-square-bracket');
        this.skipSquareBrackets = skipSquareBrackets !== null ? skipSquareBrackets : true;
        const annotationDefualtColor: string = this.storageService.read('pw-annotation-color');
        this.annotationDefualtColor = annotationDefualtColor !== null ? annotationDefualtColor : 'yellow';

        const skipUrls: boolean = this.storageService.read('pw-skip-url');
        if (skipUrls !== null) {
          this.skipUrls = skipUrls
        } else {
          this.setSkipUrls(true);
        }

        const skipScripts: boolean = this.storageService.read('pw-skip-scripts');
        this.skipScripts = skipScripts !== null ? skipScripts : true;
        const skipVertical: boolean = this.storageService.read('pw-skip-vertical');
        this.skipVertical = skipVertical !== null ? skipVertical : true;
        const skipHeaderFooter: boolean = this.storageService.read('pw-skip-header-footer');
        const pdfSkippables: Set<string> = this.storageService.read('pw-pdf-skippables');
        this.pdfSkippables = pdfSkippables !== null ? new Set(pdfSkippables) : new Set(['header-footer-footnote', 'figure', 'figure-caption', 'table', 'table-caption', 'formula']);
        if (skipHeaderFooter) {
          this.pdfSkippables.add('header-footer-footnote');
          this.storageService.remove('pw-skip-header-footer');
        }
        const sleepTimerGap: number = this.storageService.read('pw-sleep-timer');
        this.sleepTotalTimerGap = sleepTimerGap !== null ? sleepTimerGap : 30 * 60;

        let selectedVoiceType: string;
        let selectedFreeVoice: string = this.storageService.read('pw-freeVoice');
        this.selectedFreeVoice = selectedFreeVoice ? this.migrateVoiceKey(selectedFreeVoice) : this.defaultFreeVoice;

        selectedVoiceType = this.storageService.read('pw-voiceType');
        let selectedPremVoice: string = this.storageService.read('pw-premVoice');
        let selectedPlusVoice: string = this.storageService.read('pw-plusVoice');
        let lastSelectedNonGooglePremVoice: string = this.storageService.read('pw-lastNonGooglePremVoice');
        let lastSelectedNonClonedPlusVoice: string = this.storageService.read('pw-lastNonClonedPlusVoice');
        let lastSelectedPlusVoice: string = this.storageService.read('pw-lastPlusVoice');

        let selectedVoiceLanguage = this.storageService.read('pw-voiceLanguage');
        let pinnedVoices: Array<string> = this.storageService.read('pw-pinnedVoices');
        let pinnedCommunityVoices: Array<string> = this.storageService.read('pw-pinnedCommunityVoices');
        if (AppService.isPW() || AppService.isAndroid() || AppService.isIOS()) {
          if (navigator.onLine === false) {
            console.log("is in offline");
            this.selectedVoiceType = 'free';
          } else {
            console.log("is in online");
            this.selectedVoiceType = selectedVoiceType ? selectedVoiceType : 'prem';
          }
        }
        this.selectedPremVoice = selectedPremVoice ? this.migrateVoiceKey(selectedPremVoice) : this.defaultPremVoice;
        console.log("selectedPremVoice", this.selectedPremVoice);
        this.selectedPlusVoice = selectedPlusVoice ? this.migrateVoiceKey(selectedPlusVoice) : this.defaultPlusVoice;
        this.lastSelectedNonGooglePremVoice = lastSelectedNonGooglePremVoice ? this.migrateVoiceKey(lastSelectedNonGooglePremVoice) : this.defaultPremVoice;
        this.lastSelectedNonClonedPlusVoice = lastSelectedNonClonedPlusVoice ? lastSelectedNonClonedPlusVoice : this.defaultPlusVoice;
        this.lastSelectedPlusVoice = lastSelectedPlusVoice ? lastSelectedPlusVoice : null;
        this.pinnedVoices = pinnedVoices && pinnedVoices.length > 0 ? pinnedVoices : [];
        this.pinnedCommunityVoices = pinnedCommunityVoices && pinnedCommunityVoices.length > 0 ? pinnedCommunityVoices : [];
        this.selectedVoiceLanguage = selectedVoiceLanguage == 'pinned' ? 'pinned' : '';

        let speed: number = this.storageService.read('pw-speed');
        let volume: number = this.storageService.read('pw-volume');
        let isDyslexic: boolean = this.storageService.read('pw-isDyslexic');
        let isTextSpacing: boolean = this.storageService.read('pw-isTextSpacing');
        let isAutoScroll: boolean = this.storageService.read('pw-isAutoScroll');
        if (isAutoScroll === null) {
          isAutoScroll = true;
        }
        let isHighlightWord: boolean = this.storageService.read('pw-isHighlightWord');
        let beHighlighted: Array<string> = this.storageService.read('pw-beHighlighted');
        let hasHighlight: boolean = this.storageService.read('pw-hasHighlight');
        let highlightColour: string = this.storageService.read('pw-highlightColour');
        console.log("last highlight color", highlightColour);
        let fontSize: number = this.storageService.read('pw-fontSize');
        console.log("fontSize", fontSize);

        this.speed = speed ? speed : 180;
        if (this.speed < 40) {
          this.speed = 180;
        }
        this.volume = volume != null ? volume : 0.75;
        this.displayVolume = (this.volume * 100).toFixed(0);
        this.isDyslexic = isDyslexic ? isDyslexic : false;
        this.isTextSpacing = isTextSpacing ? isTextSpacing : false;
        this.isAutoScroll = isAutoScroll ? isAutoScroll : false;
        this.beHighlighted = beHighlighted ? beHighlighted : (isHighlightWord !== null ? (isHighlightWord ? ['sentence', 'word'] : ['sentence']) : ['sentence', 'word']);
        this.storageService.remove('pw-isHighlightWord');
        this.hasHighlight = hasHighlight ? hasHighlight : true;
        this.highlightColour = highlightColour ? highlightColour : 'green';
        this.fontSize = fontSize ? fontSize : 18;

        console.log("settings", {
          "selectedVoiceType": this.selectedVoiceType,
          "selectedFreeVoice": this.selectedFreeVoice,
          "selectedPremVoice": this.selectedPremVoice,
          "selectedPlusVoice": this.selectedPlusVoice,
          "isDyslexic": this.isDyslexic,
          "isTextSpacing": this.isTextSpacing,
          "isAutoScroll": this.isAutoScroll,
          "hasHighlight": this.hasHighlight,
          "highlightColour": this.highlightColour,
          "fontSize": fontSize
        });
        return Promise.resolve();
      })
      .catch((err) => {
        console.log("initSettingsFromLocalStorage error", err);
        return Promise.resolve();
      });
  }

  public migrateVoiceKey(voiceKey: string = '') {
    let newVoiceKey = voiceKey;
    let temp = voiceKey.split(" ");
    // new voice key format: no need to migrate
    if (temp.length >= 5) {
      return voiceKey;
    }
    let type = '';
    // old voice key: 3 parts "<name> <language> <type>" (e.g. "Sonia en-GB plus")
    if (temp.length > 1) {
      // extract the parts
      console.log("migrateVoiceKey temp", temp);
      type = temp.pop();
      console.log("migrateVoiceKey type", type);
      let language = temp.pop();
      console.log("migrateVoiceKey language", language);

      if (type === language) {
        language = temp.pop(); // to handle duplicated type (e.g. "local(iog) en-US free free")
      }
      let name = temp.join(" "); // to handle the case where the name has spaces e.g. Ana (Child)

      if (type !== 'plus') {
        // if not plus voice, write back to storage and return
        newVoiceKey = name + " " + language + " " + type;
        if (type === 'prem') {
          let premVoice = this.premVoicesService.getVoices().get(newVoiceKey);
          if (!premVoice) {
            newVoiceKey = this.defaultPremVoice;
          }
        } else if (type === 'free') {
          let freeVoice = this.freeVoicesService.getVoices().get(newVoiceKey);
          if (!freeVoice) {
            newVoiceKey = this.defaultFreeVoice;
          }
        }
      } else {
        // if plus voice, migrate to the 5 part format "<name> <language> <type> <source> <id>"
        let plusVoiceKeys = Array.from(this.simplePlusVoicesService.getVoices().keys());
        let plusVoiceKey = plusVoiceKeys.find(voiceKey => voiceKey.includes(name + " " + language + " " + type));
        if (plusVoiceKey) {
          console.log("migrateVoiceKey matching voice key found:", plusVoiceKey);
          newVoiceKey = plusVoiceKey;
        } else {
          newVoiceKey = this.defaultPlusVoice;
        }

      }
    }
    this.storageService.write('pw-' + type + 'Voice', newVoiceKey);
    console.log("migrateVoiceKey", newVoiceKey);
    return newVoiceKey;
  }

  public getVoiceFromKey(key) {
    if (!key) {
      return null;
    }
    // migrate the voice key first
    key = this.migrateVoiceKey(key);

    console.log("getVoiceFromKey key", key);
    // Split the key into parts
    let parts = key.split(' ');

    // Extract the language, type, source, and speakerId from the end of the parts array
    let speakerId = parts.pop();
    let source = parts.pop();
    if (speakerId === 'prem' || speakerId === 'free') {
      // it's a free or prem voice having only 3 parts instead of 5 parts
      let voiceType = speakerId;
      let voiceLanguage = source;
      let name = parts.join(' ');
      return {
        name,
        language: voiceLanguage,
        languageName: this.utilService.voiceUtilService.languageCodeToNameMapping[voiceLanguage],
        type: voiceType,
        key
      }
    }
    let type = parts.pop();
    let language = parts.pop();

    // The remaining parts belong to the voiceId
    let voiceName = parts.join(' ');
    let voiceNameParts = voiceName.split('_');
    let voiceId = '';
    if (voiceNameParts.length > 1) {
      voiceId = voiceNameParts.shift();
      voiceName = voiceNameParts.join('_');
    }

    // Further split and process the language part if needed
    language = language.split('_');
    let languageName = language[0];
    if (languageName === 'community') {
      languageName = 'Community';
      language = language[1];
    } else if (languageName === 'cloned') {
      languageName = 'Cloned';
      language = language[1];
    } else {
      language = language[0];
      languageName = this.utilService.voiceUtilService.languageCodeToNameMapping[language];
    }
    console.log("getVoiceFromKey languageName", languageName, language);
    // Return the parsed voice object
    return {
      id: voiceId,
      name: voiceName,
      language,
      languageName,
      type,
      source,
      speakerId,
      key
    };
  }

  public onOnline() {
    //  TODO this.messageService.sendMessage({ name: MessageCordovaStop });
    let selectedVoiceType: string = this.storageService.read('pw-voiceType');
    console.log("onOnline selectedVoiceType", selectedVoiceType);
    this.selectedVoiceType = selectedVoiceType ? selectedVoiceType : 'prem';

    this.messageService.sendMessage({ name: MessageSelectedVoiceTypeOnChange, data: { voiceType: this.selectedVoiceType } });
    console.log("switched to online, voice type", this.selectedVoiceType);

    if (this.selectedVoiceType === 'free') {
      const onlineFreeVoice: string = this.storageService.read('pw-onlineFreeVoice');
      if (onlineFreeVoice) {
        this.selectedFreeVoice = onlineFreeVoice;
        this.messageService.sendMessage({ name: MessageVoiceOnChange });
      }
      this.storageService.remove('pw-onlineFreeVoice');
    }
    let selectedVoice: any = this.getSelectedVoice();
    if (!selectedVoice && this.selectedVoiceType === 'plus' && this.selectedPlusVoice.includes('ms-cloned')) {
      selectedVoice = this.getVoiceFromKey(this.selectedPlusVoice);
    }
    this.utilService.updateVoiceTrigger(selectedVoice);
  }

  public onOffline() {
    this.selectedVoiceType = 'free';
    //  TODO this.messageService.sendMessage({ name: MessageCordovaStop });
    // set free voice the same language as prem
    let language = '';
    let currentType = localStorage.getItem('pw-voiceType');
    if (currentType == null) {
      this.messageService.sendMessage({ name: MessageSelectedVoiceTypeOnChange, data: { voiceType: this.selectedVoiceType } });
      return;
    }
    if (currentType.lastIndexOf('prem') > -1) {
      language = this.selectedPremVoice.split(' ').slice(-2)[0];
    } else if (currentType.lastIndexOf('plus') > -1) {
      if (this.selectedPlusVoice.includes('ms-cloned')) {
        language = this.selectedPlusVoice.split(' ')[1].split('_')[1];
      } else {
        language = this.selectedPlusVoice.split(' ')[1];
      }
    } else if (currentType.lastIndexOf('free') > -1 && this.getSelectedFreeVoice().source === 'att') {
      language = this.selectedFreeVoice.split(' ').slice(-2)[0];
      this.storageService.write('pw-onlineFreeVoice', this.selectedFreeVoice);
    }
    let bigLanguageVoice = null;
    let smallLanguageVoice = null;
    for (let voice of Array.from(this.freeVoicesService.getVoices().values())) {
      // alert(JSON.stringify(voice));
      // alert(language);
      if (voice.source !== 'google' && voice.source !== 'att') {
        if (voice.language == language) {
          smallLanguageVoice = voice;
          break;
        }
        if (bigLanguageVoice == null) {
          if (voice.language.split('-')[0] == language.split('-')[0]) {
            bigLanguageVoice = voice;
          }
        }
      }
    }
    if (smallLanguageVoice != null) {
      this.selectedFreeVoice = smallLanguageVoice.name + ' ' + smallLanguageVoice.language + ' free';
    } else if (bigLanguageVoice != null) {
      this.selectedFreeVoice = bigLanguageVoice.name + ' ' + bigLanguageVoice.language + ' free';
    }
    // alert(JSON.stringify(smallLanguageVoice));
    // alert(JSON.stringify(bigLanguageVoice));
    // alert(this.selectedFreeVoice);
    // else {
    //   this.selectedFreeVoice = this.defaultFreeVoice;
    // }
    this.messageService.sendMessage({ name: MessageSelectedVoiceTypeOnChange, data: { voiceType: this.selectedVoiceType } });
    this.messageService.sendMessage({ name: MessageVoiceOnChange });
    console.log("switched to offline, voice type", this.selectedVoiceType, this.selectedFreeVoice, this.freeVoicesService.getVoices());
    this.utilService.updateVoiceTrigger(this.freeVoicesService.getVoices().get(this.selectedFreeVoice));
  }

  public setSelectedVoiceType(type: string, toSync = true) {
    this.selectedVoiceType = type;
    if (this.onlineOfflineService.isOnline) {
      this.storageService.write('pw-voiceType', type);
      if (toSync) {
        this.updateSyncSettings();
      }
    }
    console.log('set selected voice type', this.selectedVoiceType);
  }

  public setSelectedVoiceLanguage(language) {
    this.selectedVoiceLanguage = language;
    this.storageService.write('pw-voiceLanguage', this.selectedVoiceLanguage);
  }

  public getSelectedVoiceLanguage() {
    return this.selectedVoiceLanguage;
  }

  public getSelectedVoiceType() {
    return this.selectedVoiceType;
  }

  public getSelectedVoice() {
    if (this.selectedVoiceType == 'free') {
      return this.getSelectedFreeVoice();
    } else if (this.selectedVoiceType == 'prem') {
      return this.getSelectedPremVoice();
    } else if (this.selectedVoiceType == 'plus') {
      return this.getSelectedPlusVoice();
    }
    return this.getSelectedPlusVoice();
  }

  public setDefaultVoice(type, name) {
    if (type === 'free') {
      this.defaultFreeVoice = name;
      this.storageService.write('pw-freeVoice', this.defaultFreeVoice);
    } else if (type === 'prem') {
      this.defaultPremVoice = name;
      this.storageService.write('pw-premVoice', this.defaultPremVoice);
    } else {
      this.defaultPlusVoice = name;
      this.storageService.write('pw-plusVoice', this.defaultPlusVoice);
    }
  }

  private async checkAccessToSelectedVoices() {
    try {
      await this.waitForCloned;
      const isLoggedIn = !(this.storageService.read('NAPersonal-isLog') == 0);
      let selectedPremVoice = this.premVoicesService.getVoices().get(this.selectedPremVoice);
      let selectedPlusVoice = this.simplePlusVoicesService.getVoices().get(this.selectedPlusVoice);
      if (!selectedPlusVoice && !this.selectedPlusVoice.includes('ms-cloned')) {
        if (this.simplePlusVoicesService.getVoices().get(this.lastSelectedPlusVoice)) {
          console.log("this.lastSelectedPlusVoice", this.lastSelectedPlusVoice);
          selectedPlusVoice = this.simplePlusVoicesService.getVoices().get(this.lastSelectedPlusVoice)
        } else {
          if (this.selectedPlusVoice.includes("cloned")) {
            this.selectedPlusVoice = this.lastSelectedNonClonedPlusVoice
          } else {
            this.selectedPlusVoice = this.defaultPlusVoice;
          }
          selectedPlusVoice = this.simplePlusVoicesService.getVoices().get(this.selectedPlusVoice);
        }
      }
      console.log("checkAccessToSelectedVoices", isLoggedIn, selectedPremVoice, selectedPlusVoice, this.defaultPlusVoice);

      if (!isLoggedIn) {
        this.storageService.remove('pw-login-voice');
        this.storageService.remove('pw-login-voice-type');
        if (selectedPremVoice && !selectedPremVoice.noAuth) {
          const langCode = selectedPremVoice.language;
          this.setNoAuthVoiceAsSelected(langCode, 'prem');
        }
        if (selectedPlusVoice && !selectedPlusVoice.noAuth) {
          const langCode = selectedPremVoice.language;
          this.setNoAuthVoiceAsSelected(langCode, 'plus');
        }
      } else {
        const loginVoice: string = this.storageService.read('pw-login-voice');
        const loginVoiceType: string = this.storageService.read('pw-login-voice-type');
        if (loginVoice) {
          this.storageService.remove('pw-login-voice');
          this.storageService.remove('pw-login-voice-type');
          this.setSelectedVoice(true, loginVoice, loginVoiceType, true);
        } else {
          this.storageService.remove('pw-login-voice');
          this.storageService.remove('pw-login-voice-type');
        }
      }
    } catch (err) {
      console.log("checkAccessToSelectedVoices error", err);
    }
  }

  private setNoAuthVoiceAsSelected(langCode: string, voiceType: string) {
    const voices = voiceType === 'prem' ? Array.from(this.premVoicesService.getVoices().values()) : Array.from(this.simplePlusVoicesService.getVoices().values());
    for (let i = 0; i < voices.length; i++) {
      if (voices[i].language === langCode && voices[i].noAuth) {
        this.setSelectedVoice(true, voices[i].name + ' ' + voices[i].language + ' ' + voiceType, voiceType, true);
        break;
      }
    };
  }

  public selectVoiceOfLang(lang: string) {
    const selectedVoice = this.selectedVoiceType === 'plus' ? this.selectedPlusVoice : (this.selectedVoiceType === 'prem' ? this.selectedPremVoice : this.selectedFreeVoice);
    const selectedVoiceLang = this.getVoiceFromKey(selectedVoice).language;
    console.log("selectVoiceOfLang", lang, selectedVoiceLang);
    if (selectedVoiceLang !== lang) {
      const voices = this.selectedVoiceType === 'plus' ? this.simplePlusVoicesService.getVoices() : (this.selectedVoiceType === 'prem' ? this.premVoicesService.getVoices() : this.freeVoicesService.getVoices());
      let voiceOfSameLangCode = null;
      for (let [key, value] of voices.entries()) {
        console.log("selectVoiceOfLang voice", voices.get(key).language, value);
        const langCode = lang.split("-")[0];
        const voiceLangCode = voices.get(key).language.split("-")[0];
        if (voiceLangCode === langCode) {
          voiceOfSameLangCode = key;
        }
        if (voices.get(key).language === lang) {
          console.log("setSelectedVoice", key, this.selectedVoiceType)
          return this.setSelectedVoice(true, key, this.selectedVoiceType);
        }
      }
      return this.setSelectedVoice(true, voiceOfSameLangCode, this.selectedVoiceType);
    }
  }

  public setSelectedVoice(toSync = true, name: string, type: string = null, sendVoiceOnChange: boolean = false) {
    console.log("setSelectedVoice", name, type);
    const selectedVoiceType = type ? type : this.selectedVoiceType;
    let voice = null;
    this.setSelectedVoiceType(selectedVoiceType, false);
    if (selectedVoiceType === 'free') {
      this.selectedFreeVoice = name ? name : this.defaultFreeVoice;
      this.storageService.write('pw-freeVoice', this.selectedFreeVoice);
      voice = this.getSelectedFreeVoice();
    } else if (selectedVoiceType === 'prem') {
      this.selectedPremVoice = name ? name : this.defaultPremVoice;
      this.storageService.write('pw-premVoice', this.selectedPremVoice);
      this.setLastSelectedNonGooglePremVoice();
      voice = this.getSelectedPremVoice();
    } else if (selectedVoiceType == 'plus') {
      this.setlastSelectedPlusVoice();
      this.selectedPlusVoice = name ? name : this.defaultPlusVoice;
      this.storageService.write('pw-plusVoice', this.selectedPlusVoice);
      this.setlastSelectedNonClonedPlusVoice();
      voice = this.getSelectedPlusVoice();
    }
    if (voice && this.utilService.isRtlLanguage(voice.language)) {
      $("#inputDiv").addClass('rtl');
      $("#pdfTextView").addClass('rtl');
      $("#ccText").addClass('rtl');
    } else {
      $("#inputDiv").removeClass('rtl');
      $("#pdfTextView").removeClass('rtl');
      $("#ccText").removeClass('rtl');
    }

    if (sendVoiceOnChange) {
      setTimeout(() => {
        this.messageService.sendMessage({ name: MessageVoiceOnChange });
      }, 0);
    }

    if (toSync) {
      this.updateSyncSettings();
    }
  }

  public setPinnedVoices(toSync = true) {
    this.storageService.write('pw-pinnedVoices', this.pinnedVoices);
    if (toSync) {
      this.updateSyncSettings();
    }
  }

  public setPinnedCommunityVoices(voices) {
    this.storageService.write('pw-pinnedCommunityVoices', this.pinnedCommunityVoices);
  }

  public setLoginVoice(voice) {
    this.storageService.write('pw-login-voice-type', this.selectedVoiceType);
    this.storageService.write('pw-login-voice', voice);
  }

  private setLastSelectedNonGooglePremVoice() {
    if (this.getSelectedPremVoice().source !== 'google') {
      this.lastSelectedNonGooglePremVoice = this.selectedPremVoice;
      this.storageService.write('pw-lastNonGooglePremVoice', this.lastSelectedNonGooglePremVoice);
    }
  }
  private setlastSelectedNonClonedPlusVoice() {
    let selectedPlusVoice = this.getSelectedPlusVoice();
    if (selectedPlusVoice && selectedPlusVoice.source !== 'ms-cloned') {
      this.lastSelectedNonClonedPlusVoice = this.selectedPlusVoice;
      this.storageService.write('pw-lastNonClonedPlusVoice', this.lastSelectedNonClonedPlusVoice);
    }
  }
  private setlastSelectedPlusVoice() {
    this.lastSelectedPlusVoice = this.selectedPlusVoice;
    this.storageService.write('pw-lastPlusVoice', this.lastSelectedPlusVoice);
  }

  public getLastSelectedNonGooglePremVoice(): PremVoice {
    return this.premVoicesService.getVoices().get(this.lastSelectedNonGooglePremVoice);
  }

  public getLastSelectedNonClonedPlusVoice(): PlusVoice {
    let voice = this.simplePlusVoicesService.getVoices().get(this.lastSelectedNonClonedPlusVoice);
    if (voice) {
      return voice;
    } else {
      return this.simplePlusVoicesService.getVoices().get(this.defaultPlusVoice);
    }
  }

  public getLastSelectedPlusVoice(): PlusVoice {
    let voice = this.simplePlusVoicesService.getVoices().get(this.lastSelectedPlusVoice);
    if (voice) {
      return voice;
    } else {
      return null;
    }
  }

  public getSelectedFreeVoice(voice: FreeVoice | PremVoice = null, voiceType: string = ''): FreeVoice {
    console.log("getSelectedFreeVoice", this.freeVoicesService.getVoices());
    let voices = this.freeVoicesService.getVoices();
    if (voices.size !== 0) {
      if (voice && voiceType) {
        return this.freeVoicesService.getVoices().get(voice.key);
      } else {
        if (this.selectedVoiceType === 'prem') {
          if (this.getSelectedPremVoice().source === 'google') {
            let temp = this.selectedPremVoice.split(" ");
            temp.pop();
            let googleKey = temp.join(" ") + " free";
            console.log("getSelectedFreeVoice", this.getSelectedPremVoice(), this.freeVoicesService.getVoices().get(googleKey));
            return this.freeVoicesService.getVoices().get(googleKey);
          }
        } else {
          return this.freeVoicesService.getVoices().get(this.selectedFreeVoice);
        }
      }
    } else {
      return null;
    }
  }

  public getSelectedPremVoice(): PremVoice {
    console.log("getSelectedPremVoice", this.selectedPremVoice);
    return this.premVoicesService.getVoices().get(this.selectedPremVoice);
  }

  public getSelectedPlusVoice(): PlusVoice | any {
    console.log("getSelectedPlusVoice", this.simplePlusVoicesService.getVoices().get(this.selectedPlusVoice), this.selectedPlusVoice);
    return this.simplePlusVoicesService.getVoices().get(this.selectedPlusVoice);
  }

  public setIsDyslexic(val: boolean, toSync = true) {
    this.isDyslexic = val;
    this.storageService.write('pw-isDyslexic', val);
    this.messageService.sendMessage({ name: MessageIsDyslexicChanged, data: { isDyslexic: val } });
    if (toSync) {
      this.updateSyncSettings();
    }
  }

  public setIsTextSpacing(val: boolean, toSync = true) {
    this.isTextSpacing = val;
    this.storageService.write('pw-isTextSpacing', val);
    this.messageService.sendMessage({ name: MessageIsTextSpacingChanged, data: { isTextSpacing: val } });
    if (toSync) {
      this.updateSyncSettings();
    }
  }

  public setIsAutoScroll(val: boolean) {
    this.isAutoScroll = val;
    this.storageService.write('pw-isAutoScroll', val);
    this.messageService.sendMessage({ name: MessageIsAutoScrollChanged, data: { isAutoScroll: val } });
  }

  public setBeHighlighted(beHighlighted: Array<string>) {
    this.beHighlighted = beHighlighted;
    this.storageService.write('pw-beHighlighted', this.beHighlighted);
    this.messageService.sendMessage({ name: MessageBeHighlightedChanged, data: { beHighlighted } });
  }

  public getIsDyslexic() {
    return this.isDyslexic;
  }

  public getIsTextSpacing() {
    return this.isTextSpacing;
  }

  public getIsAutoScroll() {
    return this.isAutoScroll;
  }

  public setFontSize(val: number, toSync = true) {
    this.fontSize = val;
    this.storageService.write('pw-fontSize', val);
    if (toSync) {
      this.updateSyncSettings();
    }
  }

  public getFontSize() {
    return this.fontSize;
  }

  public setHasHighlight(val: boolean) {
    this.hasHighlight = val;
    this.storageService.write('pw-hasHighlight', val);
  }

  public getHasHighlight() {
    return this.hasHighlight;
  }

  public setHighlightColour(colour: string) {
    this.highlightColour = colour;
    this.storageService.write('pw-highlightColour', colour);
  }

  public getHighlightColour() {
    return this.highlightColour;
  }

  public setSpeed(speed: number, toSync = true) {
    this.speed = speed;
    this.storageService.write('pw-speed', this.speed);
    if (toSync) {
      this.updateSyncSettings();
    }
    this.messageService.sendMessage({ name: MessageSpeedOnChange });
  }

  public setVolume(volume: number, toSync = true) {
    console.log("setvOLUME", volume);
    if (volume <= 1 && volume >= 0) {
      this.volume = Math.round(volume * 100) / 100;
      this.displayVolume = (this.volume * 100).toFixed(0)
      this.storageService.write('pw-volume', this.volume);
      if (toSync) {
        this.updateSyncSettings();
      }
    }
  }

  public getSpeed() {
    return this.speed;
  }

  public setIsCC(val, toSync = true) {
    this.isCC = val;
    this.storageService.write('pw-cc', this.isCC);
    this.messageService.sendMessage({ name: MessageIsCCChanged, data: { isCC: this.isCC } });
    if (toSync) {
      this.updateSyncSettings();
    }
  }

  public getIsCC() {
    return this.isCC;
  }

  public setSkipRoundBrackets(val) {
    this.skipRoundBrackets = val;
    this.storageService.write('pw-skip-round-bracket', this.skipRoundBrackets);
  }
  public setSkipSquareBrackets(val) {
    this.skipSquareBrackets = val;
    this.storageService.write('pw-skip-square-bracket', this.skipSquareBrackets);
  }

  public setAnnotationDefaultColor(val, toSync = true) {
    this.annotationDefualtColor = val;
    this.storageService.write('pw-annotation-color', this.annotationDefualtColor);
    if (toSync) {
      this.updateSyncSettings();
    }
  }

  public setSkipCurlyBrackets(val) {
    this.skipCurlyBrackets = val;
    this.storageService.write('pw-skip-curly-bracket', this.skipCurlyBrackets);
  }

  public setSkipUrls(val) {
    this.skipUrls = val;
    this.storageService.write('pw-skip-url', this.skipUrls);
  }

  public setSkipScripts(val) {
    this.skipScripts = val;
    this.storageService.write('pw-skip-scripts', this.skipScripts);
  }

  public setSkipVertical(val) {
    this.skipVertical = val;
    this.storageService.write('pw-skip-vertical', this.skipVertical);
  }

  setPdfSkippable(type, val) {
    if (val) {
      this.pdfSkippables.add(type);
    } else {
      this.pdfSkippables.delete(type);
    }
    this.storageService.write('pw-pdf-skippables', [...this.pdfSkippables]);
    this.updateSyncSettings();
  }

  public setSleepTimer(val) {
    this.sleepTotalTimerGap = val;
    this.sleepCurrentTimerGap = 0;
    this.alarmTimeStamp = Date.now() + this.sleepTotalTimerGap * 1000;
    this.storageService.write('pw-sleep-timer', this.sleepTotalTimerGap);
  }

  public setSleepTotalTimeToMax() {
    this.sleepTotalTimerGap = SettingsService.MAX_TOTAL_TIMER;
  }

  public setSleepTotalTimeToMin() {
    this.sleepTotalTimerGap = SettingsService.MIN_TOTAL_TIMER;
  }

  public increaseSleepTotalTimeOneGap() {
    this.sleepTotalTimerGap += SettingsService.SLEEP_TIMER_ONE_GAP;
  }

  public decreaseSleepTotalTimeOneGap() {
    this.sleepTotalTimerGap -= SettingsService.SLEEP_TIMER_ONE_GAP;
  }

  public getCharactersOneWord() {
    return 4.5;
  }

  public getSettingsToSync() {
    const params = {};

    const voiceLanguage = this.storageService.read('pw-voiceLanguage');
    const voiceType = this.storageService.read('pw-voiceType');
    const theme = this.storageService.read('pw-theme');
    const plusVoice = this.storageService.read('pw-plusVoice');
    const premVoice = this.storageService.read('pw-premVoice');
    const freeVoice = this.storageService.read('pw-freeVoice');
    const lastNonGooglePremVoice = this.storageService.read('pw-lastNonGooglePremVoice');
    const lastPlusVoice = this.storageService.read('pw-lastPlusVoice');
    const lastNonClonedPlusVoice = this.storageService.read('pw-lastNonClonedPlusVoice');
    const isAutoScroll = this.storageService.read('pw-isAutoScroll');
    const beHighlighted = this.storageService.read('pw-beHighlighted');
    const highlightColour = this.storageService.read('pw-highlightColour');
    const annotationColour = this.storageService.read('pw-annotation-color');
    const volume = this.storageService.read('pw-volume');
    const speed = this.storageService.read('pw-speed');
    const fontSize = this.storageService.read('pw-fontSize');
    const isTextSpacing = this.storageService.read('pw-isTextSpacing');
    const isDyslexic = this.storageService.read('pw-isDyslexic');
    const skipRoundBracket = this.storageService.read('pw-skip-round-bracket');
    const skipSquareBracket = this.storageService.read('pw-skip-square-bracket');
    const skipCurlyBracket = this.storageService.read('pw-skip-curly-bracket');
    const skipUrl = this.storageService.read('pw-skip-url');
    const skipVertical = this.storageService.read('pw-skip-vertical');
    const skipScript = this.storageService.read('pw-skip-scripts');
    const pdfSkippables = this.storageService.read('pw-pdf-skippables');
    const cc = this.storageService.read('pw-cc');
    const ccMode = this.storageService.read('pw-cc-mode');
    const pinnedVoices = this.storageService.read('pw-pinnedVoices');

    if (voiceLanguage) {
      params['voiceLanguage'] = voiceLanguage;
    }
    if (voiceType) {
      params['voiceType'] = voiceType;
    }
    if (theme) {
      params['theme'] = theme;
    }
    if (plusVoice) {
      params['plusVoice'] = plusVoice;
    }
    if (premVoice) {
      params['premVoice'] = premVoice;
    }
    if (freeVoice) {
      params['freeVoice'] = freeVoice;
    }
    if (lastNonGooglePremVoice) {
      params['lastNonGooglePremVoice'] = lastNonGooglePremVoice;
    }
    if (lastPlusVoice) {
      params['lastPlusVoice'] = lastPlusVoice;
    }
    if (lastNonClonedPlusVoice) {
      params['lastNonClonedPlusVoice'] = lastNonClonedPlusVoice;
    }
    if (isAutoScroll != null) {
      params['isAutoScroll'] = JSON.stringify(isAutoScroll);
    }
    if (beHighlighted) {
      params['beHighlighted'] = JSON.stringify(beHighlighted);
    }
    if (highlightColour) {
      params['highlightColour'] = highlightColour;
    }
    if (annotationColour) {
      params['annotationColour'] = annotationColour;
    }
    if (volume != null) {
      params['volume'] = JSON.stringify(volume);
    }
    if (speed != null) {
      params['speed'] = JSON.stringify(speed);
    }
    if (fontSize) {
      params['fontSize'] = JSON.stringify(fontSize);
    }
    if (isTextSpacing != null) {
      params['isTextSpacing'] = JSON.stringify(isTextSpacing);
    }
    if (isDyslexic != null) {
      params['isDyslexic'] = JSON.stringify(isDyslexic);
    }
    if (skipRoundBracket != null) {
      params['skipRoundBracket'] = JSON.stringify(skipRoundBracket);
    }
    if (skipSquareBracket != null) {
      params['skipSquareBracket'] = JSON.stringify(skipSquareBracket);
    }
    if (skipCurlyBracket != null) {
      params['skipCurlyBracket'] = JSON.stringify(skipCurlyBracket);
    }
    if (skipUrl != null) {
      params['skipUrl'] = JSON.stringify(skipUrl);
    }
    if (skipVertical != null) {
      params['skipVertical'] = JSON.stringify(skipVertical);
    }
    if (skipScript != null) {
      params['skipScript'] = JSON.stringify(skipScript);
    }
    if (pdfSkippables) {
      params['pdfSkippables'] = JSON.stringify(pdfSkippables);
    }
    if (cc != null) {
      params['cc'] = JSON.stringify(cc);
    }
    if (ccMode) {
      params['ccMode'] = ccMode;
    }
    if (pinnedVoices) {
      params['pinnedVoices'] = JSON.stringify(pinnedVoices);
    }

    return params;
  }

  getSyncSettingsFromAPI() {
    return this.amplifyControllerService.getAPI()
      .then(async (API) => {
        const config = {
          response: true,
          headers: await this.formHeaders(true),
        };
        return API.get('ExtendedApi', '/sync-settings', config)
      })
      .then(response => {
        if (response && response.data) {
          return Promise.resolve(response.data);
        } else {
          return Promise.resolve(false);
        }
      })
      .catch(error => {
        console.log("err in getSyncSettingsFromAPI", error.response);
        if (error.response && error.response.data && error.response.data.errorMessage === 'ERR_NOT_FOUND') {
          return Promise.resolve(false);
        } else {
          return Promise.reject(error);
        }
      });
  }

  updateSyncSettings() {
    console.log("updateSyncSettings");
    return this.amplifyControllerService.getAPI()
      .then(async (API) => {
        const config = {
          response: true,
          responseType: 'json',
          headers: await this.formHeaders(true),
          body: this.getSettingsToSync()
        };
        return API.put('ExtendedApi', '/sync-settings', config)
      })
      .then(response => {
        console.log("updateSyncSettings response", response);
        if (response && response.data) {
          return Promise.resolve(response.data);
        } else {
          return Promise.resolve(false);
        }
      })
      .catch(error => {
        console.log("err in updateSyncSettings", error);
        return Promise.reject(error);
      });
  }

  async updateSyncSettingsWithFetch() {
    console.log("updateSyncSettings");
    const headers = await this.formHeaders(true);
    const settingsToSync = this.getSettingsToSync();
    const url = environment.extendedApiEndpoint + '/sync-settings';

    // Create the request options
    const options = {
      method: 'PUT',
      headers: headers,
      body: JSON.stringify(settingsToSync),
      keepalive: true // Ensure the request continues even if the page is unloading
    };

    try {
      // Send the request using Fetch API with keepalive
      const response = await fetch(url, options);
      if (!response.ok) {
        console.error('Fetch request failed:', response.statusText);
      }
    } catch (error) {
      console.error('Fetch request failed:', error);
    }
  }

  private async formHeaders(needLogin = false) {
    const headers = {
      'Content-Type': 'application/json'
    }

    try {
      const auth = await this.amplifyControllerService.getAuth();
      const userSession = await auth.currentSession();
      if (userSession) {
        const idToken = userSession.getIdToken().getJwtToken();
        if (idToken) {
          headers['Authorization'] = idToken;
        }
      }
      return headers;
    } catch (err) {
      if (needLogin && err === 'No current user') {
        return Promise.reject(err);
      } else {
        return headers;
      }
    }
  }
}
